import { Space, Tag } from 'antd'
import { ColumnsType } from 'antd/es/table'
import renderDatetime from '../../../../helpers/tables/render-datetime'
import { OrderStatus } from '../../../../types/api/form-order'
import RecordBreakage from '../components/record-breakage/record-breakage'
import { FormsTableRow } from '../types/forms-table-row'

export const setLevelCell = (record: FormsTableRow) => ({
    style: { verticalAlign: 'top' as const },
    rowSpan: record.rowSpan,
})

const orderStatusColor: Record<OrderStatus, string> = {
    Создан: 'default',
    'В сборке': 'blue',
    'В пути': 'geekblue',
    'Готов к выдаче': 'cyan',
    Завершен: 'green',
}

type GetColumnsOptions = {
    onRefetch: () => void
}

export const getColumns = ({ onRefetch }: GetColumnsOptions): ColumnsType<FormsTableRow> => [
    {
        title: 'Набор',
        dataIndex: 'setId',
        width: 90,
        onCell: setLevelCell,
    },
    {
        title: 'Номер формы',
        dataIndex: 'num',
        width: 130,
    },
    {
        title: 'Цвет',
        dataIndex: 'color',
        width: 100,
        render: v => (v ? `#${v}` : undefined),
    },
    {
        title: 'Название',
        dataIndex: 'colorName',
        width: 150,
    },
    {
        title: 'В наличии',
        dataIndex: 'inStock',
        width: 110,
        render: (_v, record) => {
            if (!record.formDocumentId) return undefined
            return record.inStock === true ? 'Да' : 'Нет'
        },
    },
    {
        title: 'Последний заказ',
        key: 'lastOrder',
        width: 180,
        render: (_v, record) => {
            const order = record.form_order
            if (!order) return undefined

            return (
                <Space>
                    {order.id}
                    <Tag color={orderStatusColor[order.orderStatus]}>{order.orderStatus}</Tag>
                </Space>
            )
        },
    },
    {
        title: 'Кто заказал',
        key: 'orderedBy',
        width: 160,
        render: (_v, record) =>
            record.form_order?.user_audit?.created_by_permissions_user?.username,
    },
    {
        title: 'Закрыт',
        key: 'closedAt',
        width: 150,
        render: (_v, record) => {
            const order = record.form_order
            if (order?.orderStatus !== 'Завершен' || !order.updatedAt) return undefined
            return renderDatetime(order.updatedAt)
        },
    },
    {
        title: 'Поломка',
        key: 'breakage',
        width: 220,
        render: (_v, record) => {
            if (!record.formDocumentId) return undefined

            if (record.failureReason || record.dateOfFailure) {
                return (
                    <>
                        {record.failureReason}
                        {record.failureReason && record.dateOfFailure ? <br /> : null}
                        {record.dateOfFailure ? renderDatetime(record.dateOfFailure) : null}
                    </>
                )
            }

            return <RecordBreakage row={record} onSuccess={onRefetch} />
        },
    },
]
